// neimportovat napřímo z "@multiweb/types/react" z důvodu prevence vůči cyklické závislosti

/**
 * Konstanta pro prázdné pole. Umožňuje porovnávání referencí.
 */
export const EMPTY_ARRAY: ReadonlyArray<any> = [];

/**
 * Konstanta pro prázdný objekt. Umožňuje porovnávání referencí.
 */
export const EMPTY_OBJECT = {} as const;

/**
 * Konstanta pro nicnedělající funkci. Vhodná pro nastavení výchozích hodnot.
 */
export const doNothing = () => {
    return;
};

/**
 * Konstanta pro nicnedělající promise.
 */
export const asyncDoNothing = () => new Promise<void>((resolve) => {
    resolve();
});

/**
 * Konstanta pro funkci, která vrací svůj vstup beze změny.
 * @param value Vstupní hodnota.
 */
export const identity = <T>(value: T): T => value;

/**
 * Konstanta pro nicnedělající funkci.
 * Totéž, co {@link doNothing}, navíc vrací `undefined`.
 * Hodí se tam, kde se očekává getter, který má vracet `undefined`.
 */
export const doNothingAndReturnUndefined = (): undefined => undefined;

/**
 * Obecná délka trvání animace v milisekundách.
 */
export const ANIMATION_DURATION_MS = 200;

/**
 * Objekt obsahující hodnoty pro identifikaci událostí stisknutí kláves. Hodnoty odpovídají "key" z KeyboardEvent z "react",
 * které odpovídají https://www.w3.org/TR/uievents-key/#named-key-attribute-values.
 */
export const Key = {
    Enter: "Enter",
    Escape: "Escape",
    ArrowLeft: "ArrowLeft",
    ArrowUp: "ArrowUp",
    ArrowDown: "ArrowDown",
    ArrowRight: "ArrowRight",
    Space: " ",
    Tab: "Tab",
    Backspace: "Backspace",
    Delete: "Delete",
} as const;

/**
 * Konstanta pro nastavení tabindex. Nastaví element jako zaměřitelný, nepřidá však element do tab sequence.
 */
export const TAB_INDEX_FOCUSABLE_ONLY = -1;

/**
 * Konstanta pro nastavení tabindex. Nastaví element jako zaměřitelný a přidá ho do tab sequence.
 */
export const TAB_INDEX_FOCUSABLE_TAB_SEQUENCE = 0;

/**
 * Konstanta pro nastavení tabindex. Pořadí je určeno hodnotou čísla.
 * Prvek s hodnotou tabindex větší než 0 obdrží fokus klávesnice před prvky bez hodnoty tabindex (nebo `tabindex = "0"`).
 * @description Použití kladného tabindex {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex| se nedoporučuje }
 */
export const TAB_INDEX_FOCUSABLE_ORDER_EXPLICIT = 1;

/**
 * Konstanta pro výchozí počet dat k načtení.
 */
export const DEFAULT_DATA_COUNT_TO_LOAD = 30;

/**
 * Konstanta pro minimální výšku DataRow.
 */
export const DATA_ROW_MIN_HEIGHT = 24;

/**
 * Čas v ms používaný pro odložené zpracování události. Používá se např. pro zajištění aktualizace stavu před zpracováním události v sáze.
 */
export const EVENT_POSTPROCESS_DELAY = 100;

/**
 * Předpona pro vlastní CSS proměnné.
 * Používá se například v GridLayout komponentě při transformaci názvů props pomocí metody *transformKeysToParamCase*.
 */
export const CUSTOM_CSS_PROPERTY_PREFIX = "--";

/**
 * Předpona pro id tooltipu.
 * Používá se při formulářových komponentách jako Edit nebo NumEdit kvůli přístupnosti.
 */
export const TOOLTIP_ID_PREFIX = "error-tooltip-";
